// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionL_comp__ulxCI"};